
/**
 * Gets the keys of an enum as an array of strings.
 *
 * NOTE: This function only works on numeric enums.
 *
 * For instance, for
 *
 *  enum MyEnum {
 *    First, Second, Third
 *  }
 *
 * ["First", "Second", "Third"] is returned
 *
 * @see: https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings
 *
 * @param enumObject The enum object.
 */
export function getEnumKeys<T>(enumObject: T): string[] {
  /**
   * In javascript the typescript numeric enum is represented as
   *
   * var MyEnum;
   *  (function(MyEnum) {
   *     MyEnum[MyEnum["First"] = 0] = "First";
   *     MyEnum[MyEnum["Second"] = 1] = "Second";
   *     MyEnum[MyEnum["Third"] = 2] = "Third";
   *  }
   *
   * which is an object like this
   *
   *  Object {
   *     0: "First",
   *     1: "Second",
   *     2: "Third",
   *     First: 0,
   *     Second: 1,
   *     Third: 2
   *  }
   *
   * therefore with keys.slice(keys.length / 2) only 'First', 'Second' and 'Third' are returned.
   */
  const keys = Object.keys(enumObject);

  // TODO: Use a different method to determine the keys.
  return keys.slice(keys.length / 2);
}
